import React, { FunctionComponent } from 'react';
import { UserAction } from '@enview/interface/types/actions/UserAction';

type BillAnnotationHighlightProps = {
  annotation: UserAction;
};

const BillAnnotationHighlight: FunctionComponent<BillAnnotationHighlightProps> = (
  props,
) => {
  const { annotation, children } = props;

  return (
    <span className="annotation-highlight" data-annotation-id={annotation.id}>
      {children}
    </span>
  );
};

export default BillAnnotationHighlight;
